import LocationCityIcon from "@mui/icons-material/LocationCity";
import ListStateExams from "./List";
import { AdministrationServicePath, STATE_EXAMS } from "utils/constants";
import EditStateExams from "./Edit";
import CreateStateExams from "./Create";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  recordRepresentation: "nameBg",
  icon: <LocationCityIcon />,
  name: AdministrationServicePath + STATE_EXAMS,
  title: "Държавни изпити",
  list: <ListStateExams />,
  create: <CreateStateExams />,
  createPermission: permissions.canCreateStateExams,
  edit: <EditStateExams />,
  editPermission: permissions.canUpdateStateExams,
  permission: permissions.canPreviewStateExams,
};
